import React from "react";
import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "./index.css";
import "./font.css";
import ScrmRoutes from "./Routes";
import { Provider } from "react-redux";
import store from "./store";
import { OidcProvider } from "./context/oidc/OidcContext";
import { AuthProvider } from "./context/auth/AuthContext";
import { ToastContainer } from "@/components/Common/Toast/Toast";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ErrorBoundaryProvider } from "@/context/ErrorBoundaryContext";
import Logger from "@/utils/Logger";

const App: React.FC = () => {
  return (
    <ErrorBoundary
      onError={(error, errorInfo) => {
        // Log errors to external monitoring service (e.g., Sentry, AppInsights)
        Logger.error(
          "Application error caught by ErrorBoundary",
          error,
          ["App"],
          {
            componentStack: errorInfo.componentStack,
          },
        );
      }}
      onReset={() => {
        // Clear any application state if needed
        Logger.info("ErrorBoundary reset triggered", ["App"]);
      }}
    >
      <ErrorBoundaryProvider>
        <Provider store={store}>
          <BrowserRouter>
            <OidcProvider>
              <AuthProvider>
                <ToastContainer />
                <ScrmRoutes />
              </AuthProvider>
            </OidcProvider>
          </BrowserRouter>
        </Provider>
      </ErrorBoundaryProvider>
    </ErrorBoundary>
  );
};

export default App;
